import { combineReducers } from 'redux';

import login from '@screens/SignIn/redux/reducer';
import blogData from '@screens/Blog/redux/reducer';
import personalData from '@screens/Profile/redux/reducer';
import documentsCertificates from '@screens/Profile/ProfileDocuments/DocumentsCertificates/redux/reducer';
import documentsUpload from '@screens/Profile/ProfileDocuments/DocumentsUpload/redux/reducer';
import workExperience from '@screens/Profile/ProfileWorkExperience/redux/reducer';
import education from '@screens/Profile/ProfileEducation/redux/reducer';
import skill from '@screens/Profile/ProfileSkill/redux/reducer';
import doctorFinder from '@screens/Finder/Doctor/redux/reducer';
import packageFinder from '@screens/Finder/Package/redux/reducer';
import treatmentFinder from '@screens/Finder/Treatment/redux/reducer';
import facilityFinder from '@screens/Finder/Facility/redux/reducer';
import faqs from '@screens/FAQs/redux/reducer';
import faqsCategory from '@screens/FAQsCategory/redux/reducer';
import doctorDetails from '@screens/Details/Doctor/redux/reducer';
import treatmentDetails from '@screens/Details/Treatment/redux/reducer';
import packageDetails from '@screens/Details/Package/redux/reducer';
import facilityDetails from '@screens/Details/Facility/redux/reducer';
import companyDetails from '@screens/Details/Company/redux/reducer';
import profileSettings from '@screens/ProfileSettings/redux/reducer';
import forgotPasswordSet from '@screens/ForgotPasswordSet/redux/reducer';
import confirmationDialog from '@components/ConfirmationDialog/redux/reducer';
import mobileFilters from '@components/MobileFilters/redux/reducer';
import elasticSearch from '@components/ElasticSearch/redux/reducer';
import candidateCreate from './components/CandidateCreate/reducer';
import forgotPassword from './components/ForgotPassword/reducer';
import metadata from './components/Metadata/reducer';
import page from './components/Page/reducer';

export default combineReducers({
  login,
  personalData,
  documentsCertificates,
  documentsUpload,
  workExperience,
  education,
  skill,
  packageFinder,
  doctorFinder,
  blogData,
  treatmentFinder,
  facilityFinder,
  candidateCreate,
  faqs,
  faqsCategory,
  treatmentDetails,
  packageDetails,
  doctorDetails,
  facilityDetails,
  forgotPassword,
  companyDetails,
  metadata,
  profileSettings,
  confirmationDialog,
  forgotPasswordSet,
  mobileFilters,
  page,
  elasticSearch
});
